/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { DefaultEnvs } from '_core/types';

import { isValue, obfuscateJson } from '_core/util/';
import { Logger } from '../logger';

// apiKey App  5cd607e427753b89fda9f2ba8b003441
// apiKeu Projeto NodeJs   ba6ca890e30b895385f9a5f29014d980

// export const configure = (
//   config: BugsnagConfig,
//   environment: DefaultEnvs,
// ): void => {
//   Logger.log(config);
//   Logger.log(environment);

//   // Bugsnag.start({
//   //   apiKey: config.apiKey,
//   //   appVersion: config.appVersion,
//   //   releaseStage: environment,
//   //   user: config.user,
//   // });
// };

export const sendErrorApi = (
  environment: DefaultEnvs,
  endpoint: string,
  status: number,
  method: string,
  request: string,
  response: string,
  bugsnagClient?: any,
  name?: string,
): void => {
  const optionObfuscate = {
    listWordsObfuscate: ['password', 'pass', 'cpf', 'rg', 'name', 'lastname'],
  };

  let requestObfuscate = {};
  try {
    requestObfuscate = obfuscateJson(request, optionObfuscate);
  } catch (error) {
    console.error(error);
  }

  let responseObfuscate = {};
  try {
    responseObfuscate = obfuscateJson(response, optionObfuscate);
  } catch (error) {
    console.error(error);
  }
  const bugService = {
    Name: name ? name : '',
    Environment: environment,
    Method: method,
    Status: status,
    Endpoint: endpoint,
    Request: requestObfuscate,
    Response: responseObfuscate,
  };
  try {
    if (isValue(bugsnagClient)) {
      bugsnagClient.notify(
        new Error(`Erro de Serviço : [${bugService.Name}]`),
        (report: any) => {
          report.addMetadata('Service', bugService);
          report.severity = 'info';
        },
      );
    }
  } catch (error) {
    Logger.info('Erro ao dispirar error ao Bugsnag', error);
  }
};
